import ChangePassword, {
	action as changePasswordAction,
} from './ChangePassword';

export default ChangePassword;
export { changePasswordAction };
